<div class="container">
    <div class="container__header">
        <h1 class="container__title">
            {{'listConfiguration'|translate}}
        </h1>
        <button (click)="onHide()" class="close">
            <i class="pi pi-times icon"></i>
        </button>
    </div>

    <div class="vehicle-preview">
        <app-list-vehicle-item
            [vehicle]="vehicle"
        ></app-list-vehicle-item>

        <div class="vehicle-preview__param">
            <span>
                {{'labels.select'|translate}}
            </span>
        </div>
    </div>

    <span class="container__description">
        {{'configurationListSelectParamVehicle'|translate}}
    </span>

    <div class="container__list">
        <div *ngFor="let item of options" class="container__list__item">
            <div class="column-left">
                <p-radioButton 
                    appRadioCheckboCustomColor
                    [(ngModel)]="selectedOptionValue"
                    [value]="item.value"
                    [inputId]="item.labelId"
                    name="configListVehicle"
                    styleClass="filters-vehicle-checkbox-selected-style small"
                    size="large"
                ></p-radioButton>
                <label [for]="item.labelId" class="label">
                    {{item.title}}
                </label>
            </div>
            <div class="column-right">
                <span>
                    {{item.description}}
                </span>
            </div>
        </div>
        <div class="container__list__item e-toll">
            <div class="column-left">
                <p-radioButton 
                    appRadioCheckboCustomColor
                    [(ngModel)]="selectedOptionValue"
                    [value]="VEHICLE_LIST_TYPE_DATA.Etoll"
                    inputId="Etoll"
                    name="configListVehicle"
                    styleClass="filters-vehicle-checkbox-selected-style small"
                    size="large"
                ></p-radioButton>
                
                <label for="Etoll" class="label">
                    <img src="/assets/img/e-toll.svg" alt="">
                </label>
            </div>
            <div class="column-right">
                <span>
                    {{'sending'|translate}}
                </span>
                <img src="/assets/images/layout/etoll-sending.svg" alt="">
            </div>
        </div>
    </div>

    <p-button (onClick)="submit()" class="submit" [label]="'labels.apply'|translate" icon="pi pi-check" iconPos="right" />
</div>
